const basicPenceToString = (pence) => {
  const penceInt = parseInt(pence, 10)

  if (Number.isNaN(penceInt)) return '0.00'

  return (penceInt / 100).toFixed(2)
}

export default basicPenceToString
